import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

type Props = {
  disabled?: boolean
  label: string
  iconPath: string
  onClick?: () => void
  url: string
}

const NavButton: FC<Props> = (props) => {
  const { disabled, label, iconPath, onClick, url } = props
  const dispatch = useDispatch()

  return (
    <button
      className={`${styles.button__nav} ${styles.button_medium}`}
      disabled={disabled}
      onClick={onClick ? onClick : () => dispatch(push(url))}
    >
      <img src={iconPath} alt={label} />
      <Spacer size={6} />
      <span className={styles.button__nav__label}>{label}</span>
    </button>
  )
}

export default NavButton
